import { isApiError } from '../api';

/**
 * Plain words for what an AI request can run into (APP-048). The feature falls back cleanly:
 * Help keeps Browse help, Ask the data keeps saved questions, and nothing else in MyRewards stops.
 */
export function aiProblemWords(error: unknown, feature: 'help' | 'ask'): string {
  const rest =
    feature === 'help'
      ? 'Browse help still works.'
      : 'Your saved questions and the rest of Insights still work.';
  if (!isApiError(error)) return `Something went wrong. ${rest}`;
  switch (error.code) {
    case 'ai_daily_limit':
      return `You’ve reached today’s limit for AI questions. It resets at midnight. ${rest}`;
    case 'ai_provider_unavailable':
      return `The assistant didn’t answer just now. Try again in a minute. ${rest}`;
    case 'ai_unavailable':
      return error.problem?.detail === 'preview'
        ? `The assistant doesn’t answer in Preview, because Preview shows sample data. ${rest}`
        : `The assistant has been switched off for now. ${rest}`;
    case 'preview_read_only':
      return 'Preview is read-only. Exit preview to send this.';
    case 'rate_limited':
      return 'That was a lot of questions at once. Wait a few seconds and try again.';
    case 'network_error':
      return `We couldn’t reach MyRewards. Check your connection. ${rest}`;
    case 'invalid_request':
      return error.problem?.detail ?? 'That question needs another look.';
    default:
      return `Something went wrong. ${rest}`;
  }
}

/**
 * The server is already working out two of this person's reopened conversations or boards
 * (APP-258's two-at-once gate, SENT-168), or their re-runs this minute are spent: it's busy, not
 * missing, so the page says so and offers Try again rather than "isn't here".
 */
export function isBusy(error: unknown): boolean {
  return isApiError(error) && (error.code === 'rate_limited' || error.status === 429);
}

/** The feature was switched off, or this person can't use it now: refresh what the shell shows. */
export function isAiOff(error: unknown): boolean {
  return isApiError(error) && error.code === 'ai_unavailable';
}
